import React from 'react';
import {Typography} from "@mui/material";
import LoggedLayout from "../../component/LoggedLayout";

 const DungeonsView = () => {
    return (
        <LoggedLayout>
            <Typography>Dungeons view</Typography>
        </LoggedLayout>
    )
}

export default DungeonsView